import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React, { useCallback, useEffect } from "react";

import MDBox from "@/components/atoms/MDBox";
import { CampaignFormData } from "@/components/screens/CampaignFormPage/types";
import { ICampaignItem } from "@/interfaces/campaign.interface";
import { CampaignFormPageMessages } from "@/messages/campaigns/campaign-form-page.messages";
import { CampaignType } from "@/types/campaign.types";

import { ItemsTable } from "./components/ItemsTable";

type Props = {
  messages: CampaignFormPageMessages;
};

function ProductsTab({ messages }: Props) {
  const { values, setFieldValue } = useFormikContext<CampaignFormData>();

  const items = values?.items || [];

  const calculatePromotionalPrice = useCallback(
    (item: ICampaignItem) => {
      if (values.type === CampaignType.DiscountCoupon) {
        const discount = values.discountPercentage ? values.discountPercentage / 100 : 0;

        const originalPrice = Number(item.originalPrice || 0);
        const newPrice = originalPrice * (1 - discount);
        return newPrice;
      }
      return Number(item.promoPrice || 0);
    },
    [values.type, values.discountPercentage]
  );

  useEffect(() => {
    const updatedItems = values.items.map((item) => {
      const newPromoPrice = calculatePromotionalPrice(item);
      return { ...item, promoPrice: newPromoPrice };
    });

    setFieldValue("items", updatedItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.type, values.discountPercentage]);

  return (
    <MDBox mt={4}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <MDBox height="100%">
            <ItemsTable items={items} messages={messages} />
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default ProductsTab;
